module.exports = __webpack_public_path__ + "img/eres_8_steps_ua.505ca1c2.jpg";